module.exports = __webpack_public_path__ + "media/images/features/wedding-ceremony-cost/bycost-image-50000-8d7b07cb6a439eb2d6bcf04d4ec71689.png";